(() => {
  const roots = document.querySelectorAll('[data-mh-nav-root]');
  if (!roots.length) return;

  const desktopQuery = window.matchMedia('(min-width: 1200px)');
  const hoverQuery = window.matchMedia('(hover: hover) and (pointer: fine)');

  roots.forEach((root) => {
    const megaMenus = Array.from(root.querySelectorAll('[data-mh-mega], .mh-support-menu--desktop[data-mh-support-menu]'));
    const mobileMenu = root.querySelector('.mh-nav-menu');
    const mobilePanel = mobileMenu?.querySelector('.mh-nav-menu__panel');
    const mobileScroller = mobileMenu?.querySelector('[data-mh-nav-scroll]');
    const mobileGroups = Array.from(mobilePanel?.querySelectorAll('[data-mh-mobile-group], .mh-support-menu--mobile') || []);
    const hoverOpenedMenus = new Set();
    let openTimer;
    let closeTimer;
    let mobileScrollY = 0;

    const closeMegaMenu = (menu) => {
      menu.removeAttribute('open');
      hoverOpenedMenus.delete(menu);
      menu.closest('.mh-mega')?.querySelector('[data-mh-mega-landing-toggle]')?.setAttribute('aria-expanded', 'false');
    };

    const closeMegaMenus = (except = null) => {
      megaMenus.forEach((menu) => {
        if (menu !== except) closeMegaMenu(menu);
      });
    };

    const openMegaMenu = (menu) => {
      if (!desktopQuery.matches || menu.open) return;
      window.clearTimeout(closeTimer);
      closeMegaMenus(menu);
      menu.setAttribute('open', '');
      hoverOpenedMenus.add(menu);
      menu.closest('.mh-mega')?.querySelector('[data-mh-mega-landing-toggle]')?.setAttribute('aria-expanded', 'true');
    };

    const scheduleOpen = (menu) => {
      window.clearTimeout(closeTimer);
      window.clearTimeout(openTimer);
      openTimer = window.setTimeout(() => openMegaMenu(menu), 120);
    };

    const scheduleClose = (menu) => {
      window.clearTimeout(openTimer);
      window.clearTimeout(closeTimer);
      closeTimer = window.setTimeout(() => {
        const hoverTarget = menu.closest('.mh-mega, .mh-support-menu-wrap') || menu;
        if (!hoverTarget.matches(':hover') && !hoverTarget.contains(document.activeElement)) {
          closeMegaMenu(menu);
        }
      }, 180);
    };

    const syncMobilePanelHeight = () => {
      if (!mobileMenu?.open || !mobilePanel) return;
      const panelTop = Math.max(0, mobilePanel.getBoundingClientRect().top);
      const viewport = window.visualViewport;
      const viewportBottom = viewport ? viewport.height + viewport.offsetTop : window.innerHeight;
      const panelHeight = Math.max(0, viewportBottom - panelTop);
      mobilePanel.style.height = `${panelHeight}px`;
      mobilePanel.style.maxHeight = `${panelHeight}px`;
    };

    const lockMobilePage = () => {
      if (document.documentElement.classList.contains('mh-nav-open')) return;
      mobileScrollY = window.scrollY;
      document.documentElement.classList.add('mh-nav-open');
    };

    const unlockMobilePage = () => {
      if (!document.documentElement.classList.contains('mh-nav-open')) return;
      document.documentElement.classList.remove('mh-nav-open');
      window.scrollTo({ top: mobileScrollY, behavior: 'auto' });
    };

    megaMenus.forEach((menu) => {
      const summary = menu.querySelector('summary');
      // 2026-09-13: Resources / Help & Contact wraps open on hover over the whole item, not just the chevron.
      const hoverTarget = menu.closest('.mh-mega, .mh-support-menu-wrap') || menu;
      const landingToggle = hoverTarget.querySelector('[data-mh-mega-landing-toggle]');

      landingToggle?.addEventListener('click', (event) => {
        if (!desktopQuery.matches) return;
        event.preventDefault();
        if (menu.open) {
          closeMegaMenu(menu);
        } else {
          openMegaMenu(menu);
        }
      });

      summary?.addEventListener('click', (event) => {
        if (menu.open && hoverOpenedMenus.has(menu)) {
          event.preventDefault();
          hoverOpenedMenus.delete(menu);
          return;
        }

        hoverOpenedMenus.delete(menu);
        if (!menu.open) closeMegaMenus(menu);
      });

      hoverTarget.addEventListener('mouseenter', () => {
        if (hoverQuery.matches) scheduleOpen(menu);
      });

      hoverTarget.addEventListener('mouseleave', () => {
        if (hoverQuery.matches) scheduleClose(menu);
      });

      hoverTarget.addEventListener('focusout', () => scheduleClose(menu));
    });

    // Drawer accordion rows: <details> gives the toggle for free, the height
    // animation (and a closing animation before `open` is dropped) is added here.
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const animateGroup = (items, opening) => {
      if (!items || reducedMotion.matches || typeof items.animate !== 'function') return Promise.resolve();
      const height = `${items.scrollHeight}px`;
      const frames = opening ? [{ height: '0px', opacity: 0.4 }, { height, opacity: 1 }] : [{ height, opacity: 1 }, { height: '0px', opacity: 0.4 }];
      return items.animate(frames, { duration: 220, easing: 'ease' }).finished.catch(() => {});
    };

    mobileGroups.forEach((group) => {
      const items = group.querySelector('[data-mh-mobile-group-items], .mh-support-menu__panel');
      let closing = false;
      let animationVersion = 0;
      group.querySelector(':scope > summary')?.addEventListener('click', (event) => {
        if (!group.open) return;
        event.preventDefault();
        if (closing) return;
        closing = true;
        const version = ++animationVersion;
        items?.getAnimations().forEach((animation) => animation.cancel());
        animateGroup(items, false).then(() => {
          if (version !== animationVersion) return;
          closing = false;
          group.removeAttribute('open');
        });
      });

      group.addEventListener('toggle', () => {
        animationVersion += 1;
        closing = false;
        items?.getAnimations().forEach((animation) => animation.cancel());
        if (!group.open) return;
        animateGroup(items, true);
        mobileGroups.forEach((other) => {
          if (other !== group) other.removeAttribute('open');
        });

        window.requestAnimationFrame(() => {
          if (mobileScroller) {
            const top = group.getBoundingClientRect().top - mobileScroller.getBoundingClientRect().top;
            if (top < 0) mobileScroller.scrollTop += top;
          }
          window.scrollTo({ top: mobileScrollY, behavior: 'auto' });
        });
      });
    });

    root.querySelectorAll('[data-mh-space-browser]').forEach((browser) => {
      const tabs = Array.from(browser.querySelectorAll('[data-mh-space-group]'));
      const panels = Array.from(browser.querySelectorAll('[data-mh-space-panel]'));
      if (!tabs.length || !panels.length) return;

      const activateGroup = (key, moveFocus = false) => {
        tabs.forEach((tab) => {
          const active = tab.dataset.mhSpaceGroup === key;
          tab.classList.toggle('is-active', active);
          tab.setAttribute('aria-selected', String(active));
          tab.tabIndex = active ? 0 : -1;
          if (active && moveFocus) tab.focus();
        });
        panels.forEach((panel) => {
          const active = panel.dataset.mhSpacePanel === key;
          panel.classList.toggle('is-active', active);
          panel.hidden = !active;
        });
      };

      panels.forEach((panel) => {
        const sceneTabs = Array.from(panel.querySelectorAll('[data-mh-scene-choice]'));
        const sceneCards = Array.from(panel.querySelectorAll('[data-mh-scene-card]'));
        const sceneTitle = panel.querySelector('[data-mh-scene-title]');
        if (!sceneTabs.length || !sceneCards.length) return;

        const activateScene = (key, moveFocus = false) => {
          sceneTabs.forEach((tab) => {
            const active = tab.dataset.mhSceneChoice === key;
            tab.classList.toggle('is-active', active);
            tab.setAttribute('aria-selected', String(active));
            tab.tabIndex = active ? 0 : -1;
            if (active && moveFocus) tab.focus();
          });
          sceneCards.forEach((card) => {
            const active = card.dataset.mhSceneCard === key;
            card.classList.toggle('is-active', active);
            card.hidden = !active;
            if (active && sceneTitle) {
              sceneTitle.textContent = card.querySelector('.mh-space-browser__card')?.getAttribute('aria-label') || '';
            }
          });
        };

        sceneTabs.forEach((tab, index) => {
          tab.tabIndex = tab.classList.contains('is-active') ? 0 : -1;
          tab.addEventListener('click', () => activateScene(tab.dataset.mhSceneChoice));
          tab.addEventListener('mouseenter', () => {
            if (hoverQuery.matches) activateScene(tab.dataset.mhSceneChoice);
          });
          tab.addEventListener('keydown', (event) => {
            const keys = ['ArrowUp', 'ArrowDown', 'Home', 'End'];
            if (!keys.includes(event.key)) return;
            event.preventDefault();
            let nextIndex = index;
            if (event.key === 'ArrowUp') nextIndex = (index - 1 + sceneTabs.length) % sceneTabs.length;
            if (event.key === 'ArrowDown') nextIndex = (index + 1) % sceneTabs.length;
            if (event.key === 'Home') nextIndex = 0;
            if (event.key === 'End') nextIndex = sceneTabs.length - 1;
            activateScene(sceneTabs[nextIndex].dataset.mhSceneChoice, true);
          });
        });
      });

      tabs.forEach((tab, index) => {
        tab.tabIndex = tab.classList.contains('is-active') ? 0 : -1;
        tab.addEventListener('click', () => activateGroup(tab.dataset.mhSpaceGroup));
        tab.addEventListener('mouseenter', () => {
          if (hoverQuery.matches) activateGroup(tab.dataset.mhSpaceGroup);
        });
        tab.addEventListener('keydown', (event) => {
          const keys = ['ArrowUp', 'ArrowDown', 'Home', 'End'];
          if (!keys.includes(event.key)) return;
          event.preventDefault();
          let nextIndex = index;
          if (event.key === 'ArrowUp') nextIndex = (index - 1 + tabs.length) % tabs.length;
          if (event.key === 'ArrowDown') nextIndex = (index + 1) % tabs.length;
          if (event.key === 'Home') nextIndex = 0;
          if (event.key === 'End') nextIndex = tabs.length - 1;
          activateGroup(tabs[nextIndex].dataset.mhSpaceGroup, true);
        });
      });
    });

    // Side drawer (Kaguyasu menu-drawer pattern). <details> content is not
    // rendered while closed, so the slide-in transition needs `is-opening`
    // added one frame after `open`; closing removes the class first and drops
    // `open` once the panel has slid out.
    // WIG pass 2 (2026-09-12): while the drawer is open everything outside the header section is `inert`,
    // so the page behind the modal panel can neither be read nor tabbed into.
    const drawerInert = [];
    const setDrawerInert = (on) => {
      if (!on) {
        drawerInert.splice(0).forEach((node) => node.removeAttribute('inert'));
        return;
      }
      if (drawerInert.length) return;
      const headerSection = mobileMenu?.closest('[id^="shopify-section-"]') || root;
      for (let node = headerSection; node && node !== document.body; node = node.parentElement) {
        Array.from(node.parentElement?.children || []).forEach((sibling) => {
          if (sibling === node || sibling.hasAttribute('inert') || /^(SCRIPT|STYLE|LINK)$/.test(sibling.tagName)) return;
          sibling.setAttribute('inert', '');
          drawerInert.push(sibling);
        });
      }
    };

    let drawerCloseTimer;
    const closeDrawer = (moveFocus = false) => {
      if (!mobileMenu?.open) return;
      window.clearTimeout(drawerCloseTimer);
      mobileMenu.classList.remove('is-opening');
      drawerCloseTimer = window.setTimeout(() => {
        mobileMenu.removeAttribute('open');
        if (moveFocus) mobileMenu.querySelector(':scope > summary')?.focus({ preventScroll: true });
      }, reducedMotion.matches ? 0 : 300);
    };

    mobileMenu?.querySelector(':scope > summary')?.addEventListener('click', (event) => {
      if (!mobileMenu.open) return;
      event.preventDefault();
      closeDrawer(true);
    });

    mobileMenu?.querySelectorAll('[data-mh-nav-close]').forEach((control) => {
      control.addEventListener('click', () => closeDrawer(true));
    });

    const syncDrawer = () => {
      if (mobileMenu.open) {
        window.clearTimeout(drawerCloseTimer);
        closeMegaMenus();
        lockMobilePage();
        setDrawerInert(true);
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => {
            if (!mobileMenu.open) return;
            mobileMenu.classList.add('is-opening');
            mobilePanel?.querySelector('[data-mh-nav-close]')?.focus({ preventScroll: true });
          });
          syncMobilePanelHeight();
        });
      } else {
        mobileMenu.classList.remove('is-opening');
        mobileGroups.forEach((group) => group.removeAttribute('open'));
        mobilePanel?.style.removeProperty('height');
        mobilePanel?.style.removeProperty('max-height');
        setDrawerInert(false);
        unlockMobilePage();
      }
    };
    mobileMenu?.addEventListener('toggle', syncDrawer);
    if (mobileMenu?.open) syncDrawer();

    mobilePanel?.addEventListener('click', (event) => {
      const link = event.target.closest('a[href]');
      if (!mobileMenu.open || !link || event.defaultPrevented || event.button !== 0 ||
          event.metaKey || event.ctrlKey || event.shiftKey || event.altKey ||
          link.hasAttribute('download') || (link.target && link.target !== '_self')) return;
      const destination = new URL(link.href, window.location.href);
      if (!destination.hash || destination.origin !== window.location.origin ||
          destination.pathname !== window.location.pathname || destination.search !== window.location.search) return;

      // Unlock before the native anchor jump; a delayed close would restore the old scroll position.
      window.clearTimeout(drawerCloseTimer);
      mobileMenu.removeAttribute('open');
      syncDrawer();
      mobileMenu.querySelector(':scope > summary')?.focus({ preventScroll: true });
    });

    document.addEventListener('pointerdown', (event) => {
      if (!root.contains(event.target)) closeMegaMenus();
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Tab' && mobileMenu?.open && mobilePanel) {
        const focusable = Array.from(mobilePanel.querySelectorAll('a[href], button, summary, [tabindex="0"]'))
          .filter((element) => !element.disabled && (typeof element.checkVisibility === 'function' ? element.checkVisibility() : element.getClientRects().length > 0));
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        const active = document.activeElement;
        if (event.shiftKey && (active === first || !mobilePanel.contains(active))) {
          event.preventDefault();
          last?.focus();
        } else if (!event.shiftKey && (active === last || !mobilePanel.contains(active))) {
          event.preventDefault();
          first?.focus();
        }
        return;
      }
      if (event.key !== 'Escape') return;

      const openMega = megaMenus.find((menu) => menu.open);
      if (openMega) {
        closeMegaMenu(openMega);
        openMega.querySelector('summary')?.focus({ preventScroll: true });
        return;
      }

      if (mobileMenu?.open) closeDrawer(true);
    });

    desktopQuery.addEventListener('change', () => {
      closeMegaMenus();
      mobileMenu?.removeAttribute('open');
      mobileGroups.forEach((group) => group.removeAttribute('open'));
      unlockMobilePage();
    });

    const stickyWrapper = root.closest('.mh-header-sticky');
    if (stickyWrapper) {
      let lastY = window.scrollY;
      let scrollFrame = 0;
      const chromeOpen = () =>
        Boolean(mobileMenu?.open) ||
        document.documentElement.classList.contains('mh-search-open') ||
        megaMenus.some((menu) => menu.open);
      const syncHeader = () => {
        scrollFrame = 0;
        const y = window.scrollY;
        const headerHeight = stickyWrapper.getBoundingClientRect().height;
        if (chromeOpen() || y <= headerHeight) {
          stickyWrapper.classList.remove('is-hidden');
        } else if (y > lastY + 4 && y > headerHeight * 2) {
          stickyWrapper.classList.add('is-hidden');
        } else if (y < lastY - 4) {
          stickyWrapper.classList.remove('is-hidden');
        }
        lastY = y;
      };
      window.addEventListener('scroll', () => {
        if (!scrollFrame) scrollFrame = window.requestAnimationFrame(syncHeader);
      }, { passive: true });
      new MutationObserver(() => {
        if (chromeOpen()) stickyWrapper.classList.remove('is-hidden');
      }).observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
      mobileMenu?.addEventListener('toggle', () => stickyWrapper.classList.remove('is-hidden'));
    }

    window.addEventListener('resize', syncMobilePanelHeight, { passive: true });
    window.visualViewport?.addEventListener('resize', syncMobilePanelHeight, { passive: true });
    window.visualViewport?.addEventListener('scroll', syncMobilePanelHeight, { passive: true });
  });
})();
